module.exports = __webpack_public_path__ + "static/ben-fddcd385ca5d06a3af96415938bba286.png";